(function () {
	const group_els = document.getElementsByClassName(`accordion-group`);
	if (group_els.length === 0) {
		return;
	}

	function Group(group_el) {
		const accordion_els = group_el.getElementsByClassName(`accordion`);
		if (accordion_els.length === 0) {
			return;
		}

		const button_els = group_el.getElementsByClassName(`accordion-header`);
		if (button_els.length === 0) {
			return;
		}

		function on_click(e) {
			const button_el = e.currentTarget;

			const accordion_el = button_el.closest(`.accordion`);

			accordion_el.classList.toggle(`open`);
		}

		for (let i = 0; i < button_els.length; i++) {
			button_els[i].addEventListener(`click`, on_click);
		}
	}

	for (let i = 0; i < group_els.length; i++) {
		new Group(group_els[i]);
	}
})();

(function () {
	const accordion_els = document.getElementsByClassName(`details-accordion`);
	if (accordion_els.length === 0) {
		return;
	}

	function on_click(e) {
		const button_el = e.currentTarget;

		const accordion_el = button_el.closest(`.details-accordion`);

		accordion_el.classList.toggle(`open`);
	}

	for (let i = 0; i < accordion_els.length; i++) {
		const button_el = accordion_els[i].querySelector(`.details-accordion-header`);
		if (!button_el) {
			continue;
		}

		button_el.addEventListener(`click`, on_click);
	}
})();

(function () {
	const button_els = document.querySelectorAll(`.component-app .btn-toggle-details`);
	if (button_els.length === 0) {
		return;
	}

	function toggle(e) {
		const el = e.currentTarget;

		el.parentNode.closest(`.component`).classList.toggle(`open`);
	}

	for (let i = 0; i < button_els.length; ++i) {
		button_els[i].addEventListener(`click`, toggle);
	}
})();

(function () {
	const tab_els = document.querySelectorAll(`.component-app .tab-item header`);
	if (tab_els.length === 0) {
		return;
	}

	function toggle(e) {
		const el = e.currentTarget;

		el.parentNode.classList.toggle(`open`);
	}

	for (let i = 0; i < tab_els.length; ++i) {
		tab_els[i].addEventListener(`click`, toggle);
	}
})();

(function () {
	const button_els = document.querySelectorAll(`.component-app .popup-score-breakdown .accordion-header`);
	if (button_els.length === 0) {
		return;
	}

	function on_click(e) {
		const button_el = e.currentTarget.parentNode;

		if (button_el.classList.contains(`open`)) {
			button_el.classList.remove(`open`);
		} else {
			for (let i = 0; i < button_els.length; i++) {
				button_els[i].parentNode.classList.remove(`open`);
			}

			button_el.classList.add(`open`);
		}
	}

	for (let i = 0; i < button_els.length; i++) {
		button_els[i].addEventListener(`click`, on_click);
	}
})();

(function () {
	const list_els = document.getElementsByClassName(`toggle-list`);
	if (list_els.length === 0) {
		return;
	}

	function Toggle(list_el) {
		const open_el = list_el.parentNode.querySelector(`.btn-more`);
		if (!open_el) {
			return;
		}

		const close_el = list_el.parentNode.querySelector(`.btn-less`);
		if (!close_el) {
			return;
		}

		function open() {
			list_el.classList.add(`show-all`);
		}

		function close() {
			list_el.classList.remove(`show-all`);
		}

		open_el.addEventListener(`click`, open);
		close_el.addEventListener(`click`, close);
	}

	for (let i = 0; i < list_els.length; i++) {
		new Toggle(list_els[i]);
	}
})();

(function () {
	const button_els = document.querySelectorAll(`.component-app .welcome-bonus-right .btn`);
	if (button_els.length === 0) {
		return;
	}

	function on_click(e) {
		e.currentTarget.parentNode.classList.toggle(`open`);
	}

	for (let i = 0; i < button_els.length; i++) {
		button_els[i].addEventListener(`click`, on_click);
	}
})();
